var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconActionError = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 1.95C6.89725 1.95 1.95 6.89725 1.95 13C1.95 19.1027 6.89725 24.05 13 24.05C19.1027 24.05 24.05 19.1027 24.05 13C24.05 6.89725 19.1027 1.95 13 1.95ZM0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z",
  fill: "#CC3939"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 14.625C10.8792 14.625 9.425 16.0702 9.425 17.55C9.425 19.0298 10.8792 20.475 13 20.475C15.1208 20.475 16.575 19.0298 16.575 17.55C16.575 16.0702 15.1208 14.625 13 14.625ZM7.475 17.55C7.475 14.722 10.095 12.675 13 12.675C15.905 12.675 18.525 14.722 18.525 17.55C18.525 20.378 15.905 22.425 13 22.425C10.095 22.425 7.475 20.378 7.475 17.55Z",
  fill: "#CC3939"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.33875 6.60917C6.63744 6.16113 7.24279 6.04006 7.69083 6.33875L9.1 7.2782L10.5092 6.33875C10.9572 6.04006 11.5626 6.16113 11.8612 6.60917C12.1599 7.05721 12.0389 7.66256 11.5908 7.96125L10.8577 8.45L11.5908 8.93875C12.0389 9.23744 12.1599 9.84279 11.8612 10.2908C11.5626 10.7389 10.9572 10.8599 10.5092 10.5612L9.1 9.6218L7.69083 10.5612C7.24279 10.8599 6.63744 10.7389 6.33875 10.2908C6.04006 9.84279 6.16113 9.23744 6.60917 8.93875L7.34229 8.45L6.60917 7.96125C6.16113 7.66256 6.04006 7.05721 6.33875 6.60917Z",
  fill: "#CC3939"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1388 6.60917C14.4374 6.16113 15.0428 6.04006 15.4908 6.33875L16.9 7.2782L18.3092 6.33875C18.7572 6.04006 19.3626 6.16113 19.6612 6.60917C19.9599 7.05721 19.8389 7.66256 19.3908 7.96125L18.6577 8.45L19.3908 8.93875C19.8389 9.23744 19.9599 9.84279 19.6612 10.2908C19.3626 10.7389 18.7572 10.8599 18.3092 10.5612L16.9 9.6218L15.4908 10.5612C15.0428 10.8599 14.4374 10.7389 14.1388 10.2908C13.8401 9.84279 13.9611 9.23744 14.4092 8.93875L15.1423 8.45L14.4092 7.96125C13.9611 7.66256 13.8401 7.05721 14.1388 6.60917Z",
  fill: "#CC3939"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconActionError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_action_error.fa6cac8126c8e22480ecf46cd974c6ec.svg";